export const promotionEndpoint = 'promotion';

export enum Duration {
  all = 'Tutte',
  m24 = '24 Mesi',
  m12 = '12 Mesi',
}

export interface Promotion {
  _id: string;
  owner: string;
  code: string;
  name: string;
  descriptionBi: string;
  descriptionMono: string;
  promoDescriptionModal: string;
  endPromo: string;
  startPromo: string;
  status: string;
  modifiedAt: string;
  createdAt: string;
  cooperatives: any[];
  productFamilies: any[];
  duration: Duration;
  enableGreenPromo: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/promotion.ts